import dayjs, { Dayjs } from 'dayjs';
import duration from 'dayjs/plugin/duration';
// extend dayjs with duration plugin
dayjs.extend(duration);

export const calculateTime = (totalSeconds: number) => {
  const hrs = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  if (hrs > 0) {
    // Always hh:mm:ss
    return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }

  // Always mm:ss for short durations
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

export const parseDateValue = (value: string): Dayjs | null => {
  // parsing as DD/MM/YYYY
  const parsedCustom = dayjs(value, 'DD/MM/YYYY', true);
  if (parsedCustom.isValid()) return parsedCustom;

  // ISO format
  const parsedISO = dayjs(value);
  if (parsedISO.isValid()) return parsedISO;

  return null;
};

// Alternative function that shows only relevant units
export function formatReadableDuration(seconds: number) {
  const dur = dayjs.duration(seconds, 'seconds');

  const hours = dur.hours();
  const minutes = dur.minutes();
  const secs = dur.seconds();

  const parts = [];

  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  if (secs > 0 || parts.length === 0) parts.push(`${secs}s`);

  return parts.join(' ');
}
